import React from 'react';
import { useState, useEffect } from 'react';
import './customButton.css';

const CustomButtons = (props) => {
    let classNameButton = 'forAll';
    let isDisable = false;
    if (props.isDisable != undefined) {
        isDisable = props.isDisable;
    }

    if (props.classButton == 'outline') {
        classNameButton += ' outline';
    } else if (props.classButton == 'solid') {
        classNameButton += ' solid';
    }

    if (props.size == 'small') {
        classNameButton += ' small';
    } else if (props.size == 'big') {
        classNameButton += ' big';
    }
    if (props.isMargin == undefined) {
    } else {
        classNameButton += ' margin_top_bottom_8';
    }

    function clickButton(e) {
        props.clickFunction(e);
    }

    return (
        <>
            <button onClick={clickButton} className={classNameButton} disabled={isDisable}>
                {props.children}
            </button>
        </>
    );
};

export default CustomButtons;
